import React from 'react';
import MailToWrapper from 'flow/components/custom-components/MailToWrapper';

interface Props {
    label: string;
    children: string;
}
const ContactEmailField = ({ label, children }: Props) => (
    <div className="group mx-4 flex grow flex-wrap items-center justify-between rounded-sm p-2 hover:bg-gray-200 md:flex-row">
        <div className="whitespace-nowrap text-gray-800">{label}</div>
        <MailToWrapper recipient={children}>
            <div className="group-hover:text-link text-end text-sm text-gray-500">
                {children}
            </div>
        </MailToWrapper>
    </div>
);

export default ContactEmailField;
